import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Icon from "./icon";

const Button = styled.div`
  font-size: 14px;
  color: #0170bc;
  display: flex;
  font-weight: bold;
  align-items: center;

  span {
    margin-left: 5px;
  }
`;

function BackButton() {
  const handleOnClick = () => {};

  return (
    <Button onClick={handleOnClick}>
      <Icon type="chevron-left" size={10} /> <span>Back</span>
    </Button>
  );
}

export default BackButton;
